import moment from "moment";

export const formatDate = (date: any) => {
    const formatedDate = moment(date).format("MMM DD, YYYY");
    return formatedDate;
};